import React, { PureComponent, Fragment } from 'react';
import { object, array, bool } from 'prop-types';
import cn from 'classnames';
import { FETCH_CONTRACT_WITH_ACTIVITIES } from 'api/contract';
import { FETCH_ALL_FIELDS_AND_STORAGES } from 'api/storage';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { graphql, Query } from 'react-apollo';
import { ContractDetails, ActivityList } from 'containers';
import { getFieldsListFromData } from 'api/util';
import { MapComponent, ErrorBoundary, Responsive } from 'common/components';
import { Redirect } from 'react-router-dom';
import { base64_decode } from 'util/base64';

// import './index.css';
class ContractDetail extends PureComponent {
  static displayName = 'StorageDetail';

  static propTypes = {
    match: object,
    history: object,
    contractDetail: object,
    data: object,
    activities: array,
    loading: bool,
  };

  state = {
    confirmActive: false,
    selectedCrop: null,
  };

  render() {
    const {
      match: {
        params: { encodedId },
      },
    } = this.props;
    const id = base64_decode(encodedId);
    const WrapperClasses = cn({
      'field-wrapper__wrapper': true,
      'field-wrapper--mapstatic': true,
      columns: true,
      'is-gapless': true,
      'columns--white': !!id,
    });

    const AsideClasses = cn(
      'field-wrapper__aside',
      'column',
      'is-one-third',
      'is-gapless'
    );

    const { loading, contractDetail, activities } = this.props;
    if (!loading && contractDetail === null) return <Redirect to="/error" />;
    return (
      <ErrorBoundary>
        <Fragment>
          <div className={WrapperClasses}>
            <Responsive.Desktop>
              {this._getContractMapFragment()}
            </Responsive.Desktop>
            <aside className={AsideClasses}>
              {contractDetail && (
                <ContractDetails contract={contractDetail} id={id} />
              )}
              <div className="column__inner">
                <section>
                  <h3 className="column__title text--header">
                    Delivery Activity
                  </h3>
                  <ActivityList
                    type="contract"
                    inDetails={true}
                    activities={activities}
                    field={[]}
                  />
                </section>
              </div>
            </aside>
          </div>
        </Fragment>
      </ErrorBoundary>
    );
  }

  _getContractMapFragment() {
    return (
      <Query
        query={FETCH_ALL_FIELDS_AND_STORAGES}
        fetchPolicy="cache-and-network"
        variables={{ season: new Date().getFullYear(), active: true }}
      >
        {({ loading, error, data }) => {
          if (loading || error) return null; // handle side effects here in the future.
          const { getAllCropsForField, getAllFields, getAllStorages } = data;
          const fielsList = getFieldsListFromData({
            getAllCropsForField,
            getAllFields,
          }).map(field => ({
            geojson: field.geojson ? JSON.parse(field.geojson) : null,
            paths: field.shape,
            title: field.name,
            size: field.size,
            crops: field.crops,
            harvested: field.harvested,
          }));

          return (
            <MapComponent
              zoom={7}
              polygons={fielsList}
              storages={getAllStorages}
            />
          );
        }}
      </Query>
    );
  }
}
const mapState = ({ settings }) => ({ season: settings.season });

const enhance = compose(
  connect(mapState),
  graphql(FETCH_CONTRACT_WITH_ACTIVITIES, {
    options: ({
      match: {
        params: { encodedId },
      },
      season,
    }) => {
      const id = base64_decode(encodedId);
      const [, ...rest] = id.split(':');
      // NOTE: IDs in 2018 is CONTRACT:xxx, but from 2019 it's CONTRACT:2019:xxx
      // so joining the rest is to just avoid the first "CONTRACT:"
      return {
        variables: { season, id, contractName: rest.join(':') },
        fetchPolicy: 'cache-and-network',
      };
    },
    props: ({ data, loading }) => {
      if (loading || !data || !data.getContract) {
        return;
      }
      return {
        contractDetail: data.getContract,
        activities: data.getAllActivities,
      };
    },
  })
);

export default enhance(ContractDetail);



// WEBPACK FOOTER //
// ./src/pages/Contract/Detail/index.js